/*
  BS-CUSTOM 2026-09-09: Mindestbestellmenge nach einem Variantenwechsel korrigieren.

  assets/variant-picker.js ersetzt beim Variantenwechsel den serverseitig neu
  gerenderten Mengen-Input, kopiert davor aber unter "Transfer basic input values"
  den alten Wert in das neue Feld (gleiche id) und ueberschreibt damit das
  korrekte value aus dem Liquid. Ohne diese Korrektur:

    Sonderfertigung (min 250) -> normale Variante (min 1):  250 blieb stehen
    normale Variante (min 1)  -> Sonderfertigung (min 250): 1 blieb stehen,
                                die Formularvalidierung blockt dann beim Absenden

  Entscheidend ist, ob der Kunde die Menge selbst gesetzt hat:

    nicht angefasst -> Menge folgt der Vorgabe der neuen Variante (deren Minimum)
    selbst gesetzt  -> Menge bleibt, wird nur angehoben, wenn sie unter dem
                       neuen Minimum liegt

  Eine frueher hier verwendete Heuristik ("Wert entspricht dem vorherigen
  Minimum") konnte eine bewusst eingetippte 250 nicht vom Vorgabewert 250
  unterscheiden und haette sie beim Wechsel auf 1 gesetzt.

  Das Flag liegt am .shopify-section-Element, weil der Input selbst beim
  Variantenwechsel ersetzt wird und sein dataset dabei verloren geht. Gesetzt
  wird es nur durch echte Nutzerinteraktion (isTrusted bzw. Klick auf die
  Plus-/Minus-Schaltflaechen), nicht durch programmatische Wertzuweisungen.

  BS-CUSTOM 2026-09-22: Nie in ein Feld schreiben, in dem der Kunde gerade tippt.
  Das Multipack-Template meldet bei jedem Tastendruck im Mengenfeld einen
  Variantenwechsel. Leerte der Kunde das Feld, sah apply() ein leeres Feld und
  schrieb sofort das Minimum hinein – aus "1 löschen, 5 tippen" wurde 15.
  Jetzt überspringt apply() das fokussierte Feld; ein leeres oder zu kleines
  Feld wird erst beim Verlassen (focusout) auf das Minimum gesetzt.
*/
(function () {
  var SELECTOR = 'quantity-input input[type="number"][name="quantity"]';

  function hostOf(el) {
    return el.closest('.shopify-section') || el.closest('.js-product') || document.body;
  }

  function markUserSet(el) {
    var input = el.closest ? el.closest('quantity-input') : null;
    if (!input) return;
    hostOf(input).dataset.bsQtyUserSet = '1';
  }

  document.addEventListener('input', function (evt) {
    if (evt.isTrusted && evt.target.matches && evt.target.matches(SELECTOR)) markUserSet(evt.target);
  }, true);

  document.addEventListener('change', function (evt) {
    if (evt.isTrusted && evt.target.matches && evt.target.matches(SELECTOR)) markUserSet(evt.target);
  }, true);

  /*
    Die Plus-/Minus-Schaltflaechen aendern den Wert per stepUp()/stepDown(). Ein
    Klick allein darf das Flag NICHT setzen: Bei Menge 250 und min=250 bewirkt
    ein Minus-Klick nichts (stepDown clamped am Minimum), die Menge waere aber
    fortan als selbst gesetzt markiert - und bliebe beim Wechsel auf eine
    normale Variante bei 250 stehen. Deshalb erst nach dem Klick pruefen, ob
    sich der Wert tatsaechlich geaendert hat. Das deckt auch abgebrochene Klicks
    und das Anschlagen an ein max-Limit ab.
  */
  document.addEventListener('click', function (evt) {
    if (!evt.isTrusted || !evt.target.closest) return;
    var btn = evt.target.closest('.qty-input__btn');
    if (!btn) return;
    var wrap = btn.closest('quantity-input');
    var input = wrap && wrap.querySelector(SELECTOR);
    if (!input) return;
    var before = input.value;
    setTimeout(function () {
      if (input.value !== before) markUserSet(input);
    }, 0);
  }, true);

  function apply(scope) {
    if (!scope) return;
    scope.querySelectorAll(SELECTOR).forEach(function (input) {
      if (input === document.activeElement) return;
      var min = parseInt(input.getAttribute('min') || '', 10);
      if (!min || min < 1) return;

      var userSet = hostOf(input).dataset.bsQtyUserSet === '1';
      var value = parseInt(input.value || '', 10);

      if (!userSet || isNaN(value) || value < min) {
        if (input.value !== String(min)) {
          input.value = min;
          /*
            Programmatische Zuweisungen loesen von sich aus kein Event aus.
            Mengenabhaengige Theme-Komponenten - etwa die Gesamtsumme in
            main-product-multipack.liquid - rechnen sonst mit der alten Menge
            weiter. Die eigenen Listener oben ignorieren diese Events, weil sie
            auf isTrusted pruefen.
          */
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  document.addEventListener('focusout', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches(SELECTOR)) return;
    var min = parseInt(input.getAttribute('min') || '', 10);
    if (!min || min < 1) return;
    var value = parseInt(input.value || '', 10);
    if (isNaN(value) || value < min) {
      input.value = min;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  document.addEventListener('on:variant:change', function (evt) {
    var scope = (evt.target && evt.target.closest)
      ? (evt.target.closest('.shopify-section, .js-product') || document)
      : document;
    apply(scope);
    apply(document.querySelector('dialog[open], .modal--open'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
})();
